import React from 'react';
import {View} from '@applane/react-core-components';
import {getResolvedStyle} from './Utility';

export default class Standard extends React.Component {
  render() {
    let {
      className,
      style,
      hoverStyle,
      activeStyle,
      errorStyle,
      disabledStyle,
      Component,
      ...restProps
    } = this.props;
    let {isActive, hover, disabled, error} = restProps;
    style = getResolvedStyle({
      isActive,
      hover,
      disabled,
      error,
      style,
      hoverStyle,
      errorStyle,
      disabledStyle,
    });
    return (
      <View>
        <View className={className} style={style}>
          <Component {...restProps} />
        </View>
        <View
          style={{
            ...activeStyle,
            transform: isActive && !error ? 'scaleX(1)' : 'scaleX(0)',
            transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
          }}
        />
      </View>
    );
  }
}

Standard.defaultProps = {
  style: {
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E1E1E1',
    justifyContent: 'flex-end',
  },
  hoverStyle: {
    backgroundColor: '#f6f6f6',
  },
  activeStyle: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    borderBottomWidth: 2,
    borderColor: '#4276EC',
    borderStyle: 'solid',
  },
  errorStyle: {
    borderColor: 'red',
  },
};
